import ConfigNode from 'Model/ConfigNode'
import ConfigQuery from 'Model/ConfigQuery'

class AppView extends ConfigNode
  @className = 'AppView'

  constructor: (id) ->
    super(id)

  @list = (limit = 1000, skip = 0, params = {}) ->
    query = new ConfigQuery()
      .type(@)
      .limit(limit)
      .skip(skip)

    unless params.authenticated
      query.equalTo('isPublic', true)

    query.find(@)

  isPublic: ->
    @get('isPublic')

  setPublic: (isPublic) ->
    @set('isPublic', isPublic)

export default AppView
